<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      @vdropzone-file-added="fileAdded"
      @vdropzone-removed-file="removedFile"
    >
    </vue-dropzone>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },

  props: ['remove', 'preview'],

  data() {
    return {
      files: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        maxFilesize: 16,
        addRemoveLinks: true,
        dictDefaultMessage: 'Déposer ou Cliquer pour ajouter des fichiers',
        dictRemoveFile: 'Supprimer le fichier',
        dictCancelUpload: 'annuler le téléchargement',
      },
    };
  },

  methods: {
    fileAdded(file) {
      this.files.push(file);
      this.$emit('fileAdded', this.files);
      this.$emit('ref', this.$refs.myVueDropzone);
    },

    removedFile(file, error, xhr) {
      this.files.filter((f, index) => {
        if (f.name == file.name) {
          this.files.splice(index, 1);
        }
      });
      this.$emit('removeFileFromTask', file.name);
    },

    removeFile(flag) {
      if (flag) {
        this.$refs.myVueDropzone.removeAllFiles();
        this.$emit('removeFlag', false);
      }
    },

    manuallyAddImage(images) {
      if (images.length) {
        images.forEach((image, index) => {
          const file = { size: 150, name: image.name };
          this.$refs.myVueDropzone.manuallyAddFile(file, image.url);
        });
        this.$emit('previewFlag');
      }
    },
  },

  watch: {
    remove: {
      handler: 'removeFile',
    },
    preview: {
      handler: 'manuallyAddImage',
    },
  },
};
</script>
<style lang="scss">
.dropzone .dz-preview {
  width: 125px !important;
  height: 128px !important;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  background: #fff;
  -webkit-box-shadow: 0 1px 1px #e9ecef;
  box-shadow: 0 1px 1px #e9ecef;
  padding: 0.75rem;
  display: inline-block !important;
}
.dropzone .dz-preview .dz-image img {
  width: 100% !important;
  height: 100px !important;
  object-fit: cover !important;
}
.dropzone .dz-preview .dz-image {
  max-width: 100px !important;
}
.vue-dropzone > .dz-preview .dz-remove {
  position: absolute;
  z-index: 30;
  color: #fff;
  margin-left: -10px !important;
  padding: 0px !important;
  top: inherit;
  bottom: 15px;
  border: 2px #fff solid;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 1.1px;
  opacity: 0;
}
</style>
